import api from "../axios/index"

const getAccountId = () => {
  return sessionStorage.getItem("acc_id")
}

const getLocationId = () => {
  return JSON.parse(sessionStorage.getItem("current_loc"))?.id
}

export const getAllStatuses = async () => {
  const accountId = getAccountId()
  const locationId = getLocationId()
  const response = await api.get(`/patients/${accountId}/${locationId}/status/`)
  return response.data
}

export const createStatus = async (data) => {
  const accountId = getAccountId()
  const locationId = getLocationId()
  const response = await api.post(`/patients/${accountId}/${locationId}/status/`, data)
  return response.data
}

export const updateStatus = async (statusId, data) => {
  const accountId = getAccountId()
  const locationId = getLocationId()
  const response = await api.put(`/patients/${accountId}/${locationId}/status/${statusId}/`, data)
  return response.data
}

export const deleteStatus = async (statusId) => {
  const accountId = getAccountId()
  const locationId = getLocationId()
  const response = await api.delete(`/patients/${accountId}/${locationId}/status/${statusId}/`)
  return response.data
}
